import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d8b171b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wifiTable" }
const _hoisted_2 = { class: "wifiTitle" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "WIFI信息", -1))
const _hoisted_4 = {
  key: 0,
  class: "wifiList"
}
const _hoisted_5 = { class: "WifiNetworks" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "可用网络信息", -1))
const _hoisted_7 = {
  key: 0,
  class: "high-light"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "WifiProfiles" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "配置文件信息", -1))

import { wifiAPI } from '@/api/wifi';
import { useRoute } from 'vue-router';
import { WifiState, Wifi, WifiAvailableNetworks, WifiResponse } from '@/store/modules/wifi/types';
import { Dot11PhyTypeMap } from '@/store/modules/wifi/phyType';
import { computed, onMounted, onUnmounted, ref } from 'vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "WifiWindow",
});

interface TimeLineNode {
    content: number,
    timeToDisplay: string,
    timestamp: string,
}



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const popoverVisible = ref<boolean>(false)

const wifiState = ref({
    wifiList: [],
    isLoading: false,
} as WifiState);
const currentIntfName = ref("" as string)
const CurrentIntfInfo = ref({} as Wifi)

const intfList = ref([] as string[])
const timeLineSlice = ref<TimeLineNode[]>([])
const nowTimeNode = ref<string>("")

const getIntfList = (datas: Wifi[]) => {
    let list = []
    for (let i = 0; i < datas.length; i++) {
        list[i] = datas[i].Description
    }
    intfList.value = list
}
const selectIntf = (intfName: string) => {
    for (let i = 0; i < wifiState.value.wifiList.length; i++) {
        if (wifiState.value.wifiList[i].Description == intfName) {
            currentIntfName.value = wifiState.value.wifiList[i].Description
            CurrentIntfInfo.value = wifiState.value.wifiList[i]
            break;
        }
    }
}

// const highLight = (data: WifiAvailableNetworks): string => {
//     if (data.IsCurrentConnect === true) {
//         return `<span style="color:red;">${data.Name}(当前连接)</span>`
//     } else {
//         return data.Name
//     }
// }

const getPhyType = (data: WifiAvailableNetworks): string => {
    let phyType = Dot11PhyTypeMap.get(data.PhyType)
    if (typeof phyType === "string") {
        return phyType
    } else {
        return "unknown"
    }
}

const getTimeLine = (data: WifiResponse[]) => {
    for (let i = 0; i < data.length; i++) {
        timeLineSlice.value.push({
            content: data[i].id,
            timeToDisplay: getDisplayTime(data[i].created),
            timestamp: data[i].created
        })
    }
}
const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}

const handleChooseTime = async (data: string, id: number) => {
    popoverVisible.value = false
    wifiState.value.isLoading = true
    nowTimeNode.value = data

    try {
        const projId = projectId.value
        const uid = targetId.value;
        const response = await wifiAPI.getOneWifiInfoByUidAndTime(projId, uid, id);
        wifiState.value.wifiList = response[0].wifiInfos;
        CurrentIntfInfo.value = response[0].wifiInfos[0]
        currentIntfName.value = response[0].wifiInfos[0].Description
        getIntfList(response[0].wifiInfos)

    } catch (err) {
        wifiState.value.wifiList = [];
    } finally {
        wifiState.value.isLoading = false;
    }

}


onMounted(async () => {
    wifiState.value.isLoading = true
    try {
        const projId = projectId.value
        const uid = targetId.value;
        const response = await wifiAPI.getWifiListByUid(projId, uid);
        wifiState.value.wifiList = response[0].wifiInfos;
        CurrentIntfInfo.value = response[0].wifiInfos[0]
        currentIntfName.value = response[0].wifiInfos[0].Description
        getIntfList(response[0].wifiInfos)
        getTimeLine(response)
        nowTimeNode.value = response[0].created

    } catch (err) {
        console.log(err);
        wifiState.value.wifiList = [];
    } finally {
        wifiState.value.isLoading = false;
    }
})



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        title: " ",
        width: 400,
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"float":"right","margin-right":"50px","margin-top":"30px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (popoverVisible.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("切换时间")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_timeline, { class: "TimeLinePopover" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeLineSlice.value, (timeNode, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: index,
                  timestamp: timeNode.timeToDisplay,
                  onClick: ($event: any) => (handleChooseTime(timeNode.timestamp, timeNode.content)),
                  type: timeNode.timestamp === nowTimeNode.value ? 'primary' : ''
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(timeNode.timeToDisplay), 1)
                  ]),
                  _: 2
                }, 1032, ["timestamp", "onClick", "type"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_el_text, null, {
        default: _withCtx(() => [
          _createTextVNode("当前WLAN接口： "),
          _createVNode(_component_el_select, {
            modelValue: currentIntfName.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentIntfName).value = $event)),
            class: "m-2",
            placeholder: "Select",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (selectIntf(currentIntfName.value)))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intfList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    (wifiState.value.wifiList.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_table, {
              data: CurrentIntfInfo.value.AvailableNetworks,
              stripe: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  width: "50",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "Name",
                  label: "名称",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.IsCurrentConnect === true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.Name) + "(当前连接)", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.Name), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "Bssid",
                  label: "BSSID",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "SignalQuality",
                  label: "信号",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "PhyType",
                  label: "无线电类型",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(getPhyType(scope.row)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "Channel",
                  label: "频道",
                  align: "center"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_table, {
              data: CurrentIntfInfo.value.Profiles,
              stripe: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  width: "50",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "Name",
                  label: "名称",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "Password",
                  label: "密码",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "Authentication",
                  label: "身份验证类型",
                  align: "center"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          "image-size": 200
        }))
  ])), [
    [_directive_loading, wifiState.value.isLoading]
  ])
}
}

})